'use client'
import styles from './svgBezierCurve.module.css';
import { useRef, useEffect } from 'react';
      import { Undo2 } from 'lucide-react';
      import Link from 'next/link';

export default function Home() {

  const path = useRef(null);
  let progress = 0;
  let x = 0.5;
  let time = Math.PI / 2;
  let reqId = null;

  useEffect(() => {
    setPath(progress);
  }, [])

  const setPath = (progress) => {
    const width = window.innerWidth * 0.7;
    path.current.setAttributeNS(null, "d", `M0 250 Q${width * x} ${250 + progress}, ${width} 250`)
  }

  const lerp = (x, y, a) => x * (1 - a) + y * a

  const manageMouseEnter = () => {
    if(reqId){
      cancelAnimationFrame(reqId)
      resetAnimation()
    }
  }

  const manageMouseMove = (e) => {
    const { movementY, clientX } = e;
    const pathBound =  path.current.getBoundingClientRect();
    x = (clientX - pathBound.left) / pathBound.width;
    progress+= movementY
    setPath(progress);
  }

  const manageMouseLeave = () => {
    animateOut();
  }

  const animateOut = () => {
    const newProgress = progress * Math.sin(time);
    progress = lerp(progress, 0, 0.025);
    time+=0.2;
    setPath(newProgress);
    if(Math.abs(progress) > 0.75){
      reqId = requestAnimationFrame(animateOut);
    }
    else{
      resetAnimation();
    }
  }

  const resetAnimation = () => {
    time = Math.PI / 2;
    progress = 0;
  }

  return (
    <>
      <Link href='/projets'>
        <span className='flex items-center ps-6 pt-6 pb-4 text-black text-3xl hover:underline pointer z-100'>
          <Undo2 /> RETOUR{' '}
        </span>
      </Link>
      <div className={styles.container}>
        <div className={styles.body}>
          <div className={styles.line}>
            <div
              onMouseEnter={() => {
                manageMouseEnter();
              }}
              onMouseMove={(e) => {
                manageMouseMove(e);
              }}
              onMouseLeave={() => {
                manageMouseLeave();
              }}
              className={styles.box}
            ></div>
            <svg>
              <path ref={path}></path>
            </svg>
          </div>

                  <div className={styles.description}>
          <p>Développement Intelligent</p>
          <p>
            En combinant un design unique et une technologie avancée, nous créons des produits numériques exactement tels qu'ils ont été conçus, sans raccourcis ni simplifications.
          </p>
        </div>
        <div className={styles.tagsContainer}>
          <p>Domaines</p>
          <div className={styles.tags}>
            <p>Art</p>
            <p>Musique</p>
            <p>Design</p>
            <p>Technologie</p>
            <p>Culture</p>
            <p>Créativité</p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
